<script lang="typescript">
    import config from "../config"

    import { activeNav } from "../store"

    export let items: Nav[] = []
</script>

<ul>
    {#each items as item (item.id)}
        <li
            class:new="{item.method == 'post'}"
            class:change="{item.method == 'put'}"
            class:delete="{item.method == 'delete'}"
        >
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
                on:click="{() => {
                    $activeNav = item
                    console.log($activeNav)
                }}"
                class="name"
                class:active="{$activeNav == item}"
            >
                {item.name && item.name[config.defaultLanguage]}
                {#if item.products?.length}
                    <span class="chip">{item.products.length}</span>
                {/if}
                {#if item.productsNew}
                    <span class="chip green">+{item.productsNew}</span>
                {/if}
                {#if item.productsChange}
                    <span class="chip yellow">~{item.productsChange}</span>
                {/if}
                {#if item.productsDelete}
                    <span class="chip red">-{item.productsDelete}</span>
                {/if}
            </div>
            {#if item.subNav?.length}
                <svelte:self items="{item.subNav}" />
            {/if}
        </li>
    {/each}
</ul>

<style>
    .name {
        color: #444;
        cursor: pointer;
        line-height: 1.3em;
    }
    .name:hover {
        color: #000;
    }
    .name.active {
        color: #400;
        font-weight: bold;
    }
    ul {
        list-style: none;
        padding: 0;
        padding-left: 20px;
    }
    ul li::before {
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
        position: absolute;
    }
    ul li.new::before {
        content: "+";
        color: darkgreen;
    }
    ul li.change::before {
        content: "~";
        color: darkorange;
    }
    ul li.delete::before {
        content: "-";
        color: darkred;
    }
</style>
